import { useEffect, useState } from 'react';
import { DD } from '@tcc/analytics';
import { reportError } from '../utils/datadog';

// Types
import { BootStep } from '../types/boot';

const initialState = {
  isBooting: true,
};

export function useBoot(bootSteps: BootStep[]) {
  const [status, setStatus] = useState(initialState);

  useEffect(() => {
    DD.startDurationVital('app_boot', {
      context: { stepCount: bootSteps.length },
      description: 'Time to run all boot steps before the app is interactive',
    });

    Promise
      .all(bootSteps.map(step => step.installer()))
      .then(() => {
        DD.stopDurationVital('app_boot');
        setStatus({ isBooting: false });
      })
      .catch((error) => {
        // A boot installer (e.g. i18n setup) rejected. Report it, then still
        // unblock the app so users are not stuck on the boot spinner forever.
        reportError('FieldViewBootStepError', error, { phase: 'boot', stepCount: bootSteps.length });
        DD.stopDurationVital('app_boot');
        setStatus({ isBooting: false });
      });
  }, [bootSteps]);

  return status;
}
